export const ComposerFragment = ({ children }: { children?: React.ReactNode }): JSX.Element => (
  <>{children}</>
);
